export default __webpack_public_path__ + "static/media/tutord-signin-page.c4109dc5.svg";